import AddDevelopersPage from "../../../component/users/developers/AddDevelopersPage"

 
 
function AddDevelopers() {
  return (
    <div className="page-body"><AddDevelopersPage/></div>
  )
}

export default AddDevelopers